export default __webpack_public_path__ + "static/media/Nashchekin_Alexey_Sergeevich.ed2757e7.webp";